import styled from '@emotion/styled';
import { InnerContent, InnerTitle, TextWrapper } from '..';
import { Table, Td, THead } from './TableComponents';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const Container = styled.div`
  display: grid;
  row-gap: 16px;
`;

const InfoContainer = styled.div`
  display: grid;
  padding: 24px;
  background-color: ${colors.whiteGrey4};
`;

const InfoText = styled.span<{ indent?: number }>`
padding-left: ${({ indent }) => indent && (indent * 30)}px;
color: ${colors.arsenic};
font-size: 16px;
word-break: keep-all;

@media (max-width: ${breakpointMedium}) {
  padding-left: ${({ indent }) => indent && (indent * 15)}px;
  font-size: 12px;
}
`;

export const PCCPRegistration = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>한국직업능력개발원 등록된 민간 자격증</InnerTitle>
      <InnerContent>프로그래머스 코딩전문역량인증(PCCP)는 한국직업능력개발원에 등록된 민간자격이며, 아래와 같이 등록되어 있습니다.</InnerContent>
    </TextWrapper>
    <Table>
      <THead>
        <tr>
          <Td>자격명</Td>
          <Td>등록번호</Td>
        </tr>
      </THead>
      <tbody>
        <tr>
          <Td width="65%">Programmers Certified Coding Professional(Python)</Td>
          <Td>2022-002967</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified Coding Professional(Java)</Td>
          <Td>2022-002966</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified Coding Professional(JavaScript)</Td>
          <Td>2022-002965</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified Coding Professional(C++)</Td>
          <Td>2022-002964</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified Coding Professional(C)</Td>
          <Td>2022-002963</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified Coding Professional(C#)</Td>
          <Td>2024-001828</Td>
        </tr>
      </tbody>
    </Table>
    <InfoContainer>
      <InfoText>발급기관: (주)그렙</InfoText>
      <InfoText>환불규정</InfoText>
      <InfoText indent={1}>1. 접수 기간 내 취소: 응시료 전액 환불</InfoText>
      <InfoText indent={1}>2. 접수 기간 내 취소: 응시료 전액 환불</InfoText>
      <InfoText indent={2}>- 접수 마감 이후부터 시험 시행 1일 전까지 50% 환불</InfoText>
      <InfoText indent={2}>- 전액 환불 사유에 해당하는 사항이 있을 경우 자격시험 홈페이지를 통해 증빙자료 첨부</InfoText>
      <InfoText indent={1}>3. 쿠폰 접수: 접수 기간 내 취소 신청이 가능하며 쿠폰은 복원 처리됨. 단, 시험 시행 1일 전에는 취소 불가</InfoText>
    </InfoContainer>
  </Container>
);

export const PCCERegistration = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>한국직업능력개발원 등록된 민간 자격증</InnerTitle>
      <InnerContent>프로그래머스 코딩필수역량인증(PCCE)은 한국직업능력개발원에 등록된 민간자격이며, 아래와 같이 등록되어 있습니다.</InnerContent>
    </TextWrapper>
    <Table>
      <THead>
        <tr>
          <Td>자격명</Td>
          <Td>등록번호</Td>
        </tr>
      </THead>
      <tbody>
        <tr>
          <Td width="65%">Programmers Certified Coding Essential(Python)</Td>
          <Td>2022-002970</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified Coding Essential(Java)</Td>
          <Td>2022-002969</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified Coding Essential(C++)</Td>
          <Td>2022-002968</Td>
        </tr>
      </tbody>
    </Table>
    <InfoContainer>
      <InfoText>발급기관: (주)그렙</InfoText>
      <InfoText>환불규정</InfoText>
      <InfoText indent={1}>1. 접수 기간 내 취소: 응시료 전액 환불</InfoText>
      <InfoText indent={1}>2. 접수 기간 내 취소: 응시료 전액 환불</InfoText>
      <InfoText indent={2}>- 접수 마감 이후부터 시험 시행 1일 전까지 50% 환불</InfoText>
      <InfoText indent={2}>- 전액 환불 사유에 해당하는 사항이 있을 경우 자격시험 홈페이지를 통해 증빙자료 첨부</InfoText>
      <InfoText indent={1}>3. 쿠폰 접수: 접수 기간 내 취소 신청이 가능하며 쿠폰은 복원 처리됨. 단, 시험 시행 1일 전에는 취소 불가</InfoText>
    </InfoContainer>
  </Container>
);

export const PCSQLRegistration = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>한국직업능력개발원 등록된 민간 자격증</InnerTitle>
      <InnerContent>프로그래머스 SQL역량인증(PCSQL)은 한국직업능력개발원에 등록된 민간자격이며, 아래와 같이 등록되어 있습니다.</InnerContent>
    </TextWrapper>
    <Table>
      <THead>
        <tr>
          <Td>자격명</Td>
          <Td>등록번호</Td>
        </tr>
      </THead>
      <tbody>
        <tr>
          <Td width="65%">Programmers Certified SQL(MySQL)</Td>
          <Td>2023-002339</Td>
        </tr>
        <tr>
          <Td width="65%">Programmers Certified SQL(Oracle)</Td>
          <Td>2023-002338</Td>
        </tr>
      </tbody>
    </Table>
    <InfoContainer>
      <InfoText>발급기관: (주)그렙</InfoText>
      <InfoText>환불규정</InfoText>
      <InfoText indent={1}>1. 접수 기간 내 취소: 응시료 전액 환불</InfoText>
      <InfoText indent={1}>2. 접수 기간 내 취소: 응시료 전액 환불</InfoText>
      <InfoText indent={2}>- 접수 마감 이후부터 시험 시행 1일 전까지 50% 환불</InfoText>
      <InfoText indent={2}>- 전액 환불 사유에 해당하는 사항이 있을 경우 자격시험 홈페이지를 통해 증빙자료 첨부</InfoText>
      <InfoText indent={1}>3. 쿠폰 접수: 접수 기간 내 취소 신청이 가능하며 쿠폰은 복원 처리됨. 단, 시험 시행 1일 전에는 취소 불가</InfoText>
    </InfoContainer>
  </Container>
);
